// extracted by mini-css-extract-plugin
module.exports = {"item-with-image-hoverable-small":"item-with-image-hoverable-small__XUnPd"};